import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import horizonImage from '@/assets/leaders-threshold-horizon.jpg';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

const LeadersThreshold = () => {
  const handleScheduleCall = () => {
    window.open('https://calendly.com/kentfrazier/30-minutes', '_blank');
  };

  const content = useScrollReveal<HTMLDivElement>();

  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      {/* Painterly horizon background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${horizonImage})` }}
        aria-hidden="true"
      />
      {/* Layered overlays for legibility */}
      <div className="absolute inset-0 bg-foreground/70" />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground/50 via-foreground/40 to-foreground/85" />
      {/* Centered radial darkener behind the headline */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at center, hsl(var(--foreground) / 0.55) 0%, transparent 65%)',
        }}
        aria-hidden="true"
      />

      <div
        ref={content.ref}
        className={`container-mobile relative z-10 max-w-4xl mx-auto py-32 sm:py-40 text-center transition-all duration-1000 ${
          content.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Eyebrow with centered rule */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <span className="h-px w-12 bg-primary" aria-hidden="true" />
          <p className="text-primary font-semibold tracking-[0.25em] uppercase text-xs">
            The Threshold
          </p>
          <span className="h-px w-12 bg-primary" aria-hidden="true" />
        </div>

        <h2
          className="text-background text-5xl sm:text-6xl lg:text-7xl mb-10 leading-[1.0]"
          style={{
            textWrap: 'balance',
            textShadow: '0 2px 24px hsl(var(--foreground) / 0.9), 0 0 8px hsl(var(--foreground) / 0.7)',
          }}
        >
          If something in you just{' '}
          <span
            className="italic font-display"
            style={{
              color: '#F5A572',
              textShadow:
                '0 2px 18px hsl(var(--foreground) / 0.95), 0 0 10px hsl(var(--foreground) / 0.85)',
            }}
          >
            leaned forward.
          </span>
        </h2>

        <p className="text-background/90 text-xl sm:text-2xl leading-relaxed mb-14 max-w-2xl mx-auto font-light drop-shadow">
          A first conversation is just that. A conversation. No pitch, no pressure. Thirty minutes to see whether this is the kind of work you're being called toward, and whether we're the right fit to walk it together.
        </p>

        <Button
          onClick={handleScheduleCall}
          size="lg"
          className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold text-lg px-10 py-7 rounded-full transition-all duration-300 hover:shadow-2xl hover:shadow-primary/30 hover:scale-105"
        >
          Begin the Conversation
          <ArrowRight className="h-5 w-5 ml-2" />
        </Button>
      </div>
    </section>
  );
};

export default LeadersThreshold;
